<div class="patient-summary">
  <div class="row">
    @if (control().displayPracticeDetails) {
      <div class="col-sm"><h2 class="mb-0">{{ treatingDoctorName }}</h2></div>
    }
  </div>
  <div class="row">
    <div class="col-sm"><h1 class="mb-0"><span>{{ patient().profileId | patientNumberPad }}</span> - {{ patient().displayName }}</h1></div>
  </div>
  <div class="row">
    <div class="col-sm">
      <mat-form-field color="primary">
        <mat-label>ID Number</mat-label>
        <input matInput readonly type="text" value="{{ patient()?.identityNumber }}" />
      </mat-form-field>
      @if (control().displayContactDetails) {
        <mat-form-field color="primary">
          <mat-label>Tel</mat-label>
          <input matInput readonly type="text" value="{{ patient()?.tel }}"/>
        </mat-form-field>
      }
      @if (control().displayContactDetails) {
        <mat-form-field color="primary">
          <mat-label>Cell</mat-label>
          <input matInput readonly type="text" value="{{ patient()?.cell }}" />
        </mat-form-field>
      }
      @if (control().displayContactDetails) {
        <mat-form-field color="primary">
          <mat-label>Email</mat-label>
          <input matInput readonly type="text" value="{{ patient()?.email }}"/>
        </mat-form-field>
      }
    </div>
    @if (control().displayAddressDetails) {
      <div class="col-sm">
        <mat-form-field color="primary">
          <mat-label>Address</mat-label>
          <textarea matInput readonly rows="6">{{ patient()?.address }}</textarea>
        </mat-form-field>
      </div>
    }
    <div class="col-sm">
      @if (control().displayMedicalAidDetails) {
        <mat-form-field color="primary">
          <mat-label>Scheme</mat-label>
          <input matInput readonly type="Text" value="{{ patient()?.medicalAid?.scheme }}" />
        </mat-form-field>
      }
      @if (control().displayMedicalAidDetails) {
        <mat-form-field color="primary">
          <mat-label>Mem No</mat-label>
          <input matInput readonly type="Text" value="{{ patient()?.medicalAid?.medicalAidNumber }}" />
        </mat-form-field>
      }
      @if (control().displayMedicalAidDetails) {
        <mat-form-field color="primary">
          <mat-label>Dep Code</mat-label>
          <input matInput readonly type="Text" value="{{ patient()?.medicalAid?.dependantCode }}" />
        </mat-form-field>
      }
      @if (control().displayDoctorsDetails) {
        <mat-form-field color="primary">
          <mat-label>Referring Doctor</mat-label>
          <input matInput readonly type="Text" value="{{ patient()?.allDoctors }}" />
        </mat-form-field>
      }
    </div>
  </div>
</div>
